import {  FlatList } from 'react-native';
import Accordion from '@sharedComponents/Accordion/Accordion';
import {  ThemedText, ThemedView } from '@app/theme';
import {bajajFaq,nonBajajFaq} from './data'
const FaqContainer = ({lender,contactNumber}) => {
  return (
    <>
      <ThemedView backgroundColor='bg-surface-primary' my="2xl">
        <ThemedView p="lg" flexDirection='row' justifyContent='space-between' alignItems='center'>
          <ThemedText variant='h5s' color='text-primary'>
            FAQs
          </ThemedText>
        </ThemedView>
        <FlatList
          contentContainerStyle={{ marginHorizontal: 16 }}
          data={lender?.toLowerCase() === 'bajaj' ? bajajFaq(contactNumber) : nonBajajFaq(contactNumber)}
          renderItem={({ item }) => (
            <Accordion
              id={item.id}
              description={item.description}
              title={item.title}
            />
          )}
          showsVerticalScrollIndicator={true}
        />
      </ThemedView>
    </>
  );
};

export default FaqContainer;
